import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import { AlfreHttp } from 'alfre-http';
import { CommonConfig } from '../../configs/config.common';

@Component({
    components: {
    },
})
export default class CreateAgent extends Vue {
    public title: string = 'CreateAgent';

    public alfre = new AlfreHttp.Provider();

    public configs = new CommonConfig();

    public model = true;

    @Prop()
    public onCreatedCallback: any;

    @Prop()
    public onCancelCallback: any;

    @Prop()
    public formInline: any;

    public formRules = {
    };

    public async createAgent() {
        await this.onCreatedCallback(this.formInline);
        const table: any = this.$refs['formInline'];
        const apiHost = this.configs.apiHost;
        const url = `${apiHost}/partner/creation`;
        this.alfre.setParamType(AlfreHttp.ParamType.URLEncode);
        this.alfre.setMethod(AlfreHttp.MethodType.Post);
        this.alfre.setUri(url);
        this.alfre.setPostBody({
            name: this.formInline.name,
            mobile: this.formInline.mobile,
            isCompany: false
        });
        await this.alfre.fetch('CreateAgent');
        table.resetFields();
        return;
    }

    public async cancelAgent() {
        await this.onCancelCallback(this.formInline);
        const table: any = this.$refs['formInline'];
        table.resetFields();
        return;
    }
}
